import AdvertisingImportPage from './AdvertisingImportPage';

export default AdvertisingImportPage;
